import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { CONTACTS, SERVICES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm() {
  const [form, setForm] = useState({
    nome: "",
    email: "",
    telefono: "",
    comune: "",
    servizio: "",
    messaggio: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.telefono || !form.messaggio) {
      toast.error("Compila tutti i campi obbligatori");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Richiesta inviata! Davide ti ricontatterà al più presto.");
      setForm({ nome: "", email: "", telefono: "", comune: "", servizio: "", messaggio: "" });
    } catch (err) {
      console.error(err);
      toast.error("Errore nell'invio. Prova a chiamare direttamente Davide al " + CONTACTS.phoneDisplay);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4" data-testid="contact-form">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="field-label" htmlFor="nome">Nome e cognome *</label>
          <input
            id="nome"
            name="nome"
            type="text"
            required
            value={form.nome}
            onChange={onChange}
            placeholder="Mario Rossi"
            className="field"
            data-testid="input-nome"
          />
        </div>
        <div>
          <label className="field-label" htmlFor="telefono">Telefono *</label>
          <input
            id="telefono"
            name="telefono"
            type="tel"
            required
            value={form.telefono}
            onChange={onChange}
            placeholder="335 123 4567"
            className="field"
            data-testid="input-telefono"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="field-label" htmlFor="email">Email *</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            value={form.email}
            onChange={onChange}
            placeholder="mario@email.it"
            className="field"
            data-testid="input-email"
          />
        </div>
        <div>
          <label className="field-label" htmlFor="comune">Comune di intervento</label>
          <input
            id="comune"
            name="comune"
            type="text"
            value={form.comune}
            onChange={onChange}
            placeholder="Modena, Carpi, Bologna..."
            className="field"
            data-testid="input-comune"
          />
        </div>
      </div>

      <div>
        <label className="field-label" htmlFor="servizio">Servizio richiesto</label>
        <select
          id="servizio"
          name="servizio"
          value={form.servizio}
          onChange={onChange}
          className="field"
          data-testid="select-servizio"
        >
          <option value="">Seleziona un servizio...</option>
          {SERVICES.map((s) => (
            <option key={s.id} value={s.title}>{s.title}</option>
          ))}
          <option value="Altro">Altro</option>
        </select>
      </div>

      <div>
        <label className="field-label" htmlFor="messaggio">Messaggio *</label>
        <textarea
          id="messaggio"
          name="messaggio"
          required
          value={form.messaggio}
          onChange={onChange}
          rows={5}
          placeholder="Descrivici la richiesta. Se possibile, indica: tipo di camino/stufa, accesso al tetto (Velux/lucernario), e allega una foto tramite WhatsApp."
          className="field resize-none"
          data-testid="textarea-messaggio"
        />
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-2">
        <button type="submit" className="btn-primary" disabled={loading} data-testid="submit-contact">
          {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
          {loading ? "Invio..." : "Invia richiesta"}
        </button>
        <span className="text-sm" style={{ color: "var(--muted)" }}>
          Riceverai una risposta all'indirizzo <strong>{CONTACTS.email}</strong>
        </span>
      </div>
    </form>
  );
}
